var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.licitacionParticipantes},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":item.createdAt}})]}},{key:"item.asistio",fn:function(ref){
var item = ref.item;
return [(_vm.mixValidaScopesActions(2))?_c('asistio-switch',{attrs:{"participanteJuntaAclaraciones":item}}):_vm._e()]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }